export default __webpack_public_path__ + "static/media/feature-left-mobile.06363c74.png";